var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { SdsInputBase } from '../_sds-input-base';
import styles from './sds-input-select.lit.scss';
import { SdsIcon } from '../../icon/sds-icon.lit';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * Control that represents select input.
 */
let SdsInputSelect = (() => {
    var _SdsInputSelect_opened_accessor_storage, _SdsInputSelect_isSelect_accessor_storage, _SdsInputSelect__input_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-input-select')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsInputBase;
    let _opened_decorators;
    let _opened_initializers = [];
    let _opened_extraInitializers = [];
    let __input_decorators;
    let __input_initializers = [];
    let __input_extraInitializers = [];
    var SdsInputSelect = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsInputSelect_opened_accessor_storage.set(this, __runInitializers(this, _opened_initializers, false));
            _SdsInputSelect_isSelect_accessor_storage.set(this, (__runInitializers(this, _opened_extraInitializers), true));
            _SdsInputSelect__input_accessor_storage.set(this, __runInitializers(this, __input_initializers, void 0));
            this._currentType = (__runInitializers(this, __input_extraInitializers), 'select');
            this.onInputClick = (e) => {
                if (!(e.target instanceof SdsIcon && e.target.id === 'sds-input-select-caret')) {
                    this.dispatchEvent(new CustomEvent(SdsInputSelect.INPUT_CLICKED_EVENT, {
                        detail: { value: this.value },
                        bubbles: false,
                        composed: false,
                    }));
                }
            };
            this.handleCaret = () => {
                this.dispatchEvent(new CustomEvent(SdsInputSelect.CARET_CHANGED_EVENT, {
                    detail: { value: this.value },
                    bubbles: false,
                    composed: false,
                }));
            };
            this.handleKeyDown = (event) => {
                switch (event.code) {
                    case 'ArrowUp':
                    case 'ArrowDown':
                        event.preventDefault();
                        break;
                }
            };
        }
        get opened() { return __classPrivateFieldGet(this, _SdsInputSelect_opened_accessor_storage, "f"); }
        set opened(value) { __classPrivateFieldSet(this, _SdsInputSelect_opened_accessor_storage, value, "f"); }
        get isSelect() { return __classPrivateFieldGet(this, _SdsInputSelect_isSelect_accessor_storage, "f"); }
        set isSelect(value) { __classPrivateFieldSet(this, _SdsInputSelect_isSelect_accessor_storage, value, "f"); }
        get _input() { return __classPrivateFieldGet(this, _SdsInputSelect__input_accessor_storage, "f"); }
        set _input(value) { __classPrivateFieldSet(this, _SdsInputSelect__input_accessor_storage, value, "f"); }
        getInput() {
            return this._input;
        }
        setCursorToEnd() {
            const valueLength = this.value.length;
            this._input.selectionStart = valueLength;
            this._input.selectionEnd = valueLength;
        }
        render() {
            return html `
            <div class="${this.getClasses()} sds-input--select">
                <div class="sds-input__wrapper" @click="${this.onInputClick}">
                    ${this.renderInput(this._currentType)} ${this.renderActionContainer()}
                    ${this.renderCaret()}
                </div>
                ${this.renderMessages()}
            </div>
        `;
        }
        handleInput(e) {
            super.handleInput();
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            e === null || e === void 0 ? void 0 : e.preventDefault();
        }
        renderCaret() {
            if (this.opened) {
                return html `
                <sds-icon
                    id="sds-input-select-caret"
                    class="sds-input__caret"
                    @click="${this.handleCaret}"
                    name="arrow_up_small"
                    size="24"
                ></sds-icon>
            `;
            }
            else {
                return html `
                <sds-icon
                    id="sds-input-select-caret"
                    class="sds-input__caret"
                    @click="${this.handleCaret}"
                    name="arrow_down_small"
                    size="24"
                ></sds-icon>
            `;
            }
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        handleBlur() {
            if (!this.opened) {
                this.focused = false;
            }
        }
        handleClear(event) {
            this.dispatchEvent(new CustomEvent(SdsInputSelect.CLEARED_EVENT, {
                detail: { value: this.value },
                bubbles: false,
                composed: false,
            }));
            this.value = this.emptyValue();
            event.stopPropagation();
        }
        emptyValue() {
            return '';
        }
        convertValue(value) {
            return value;
        }
        willUpdate(_changedProperties) {
            if ((_changedProperties.has('hasPrefix') && this.hasPrefix) ||
                (_changedProperties.has('hasSuffix') && this.hasSuffix)) {
                this.hasClear = false;
            }
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            this._input.addEventListener('keydown', this.handleKeyDown);
        }
    };
    _SdsInputSelect_opened_accessor_storage = new WeakMap();
    _SdsInputSelect_isSelect_accessor_storage = new WeakMap();
    _SdsInputSelect__input_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsInputSelect");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _opened_decorators = [property({ attribute: false })];
        __input_decorators = [query('input.sds-input__element')];
        __esDecorate(_classThis, null, _opened_decorators, { kind: "accessor", name: "opened", static: false, private: false, access: { has: obj => "opened" in obj, get: obj => obj.opened, set: (obj, value) => { obj.opened = value; } }, metadata: _metadata }, _opened_initializers, _opened_extraInitializers);
        __esDecorate(_classThis, null, __input_decorators, { kind: "accessor", name: "_input", static: false, private: false, access: { has: obj => "_input" in obj, get: obj => obj._input, set: (obj, value) => { obj._input = value; } }, metadata: _metadata }, __input_initializers, __input_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsInputSelect = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.CLEARED_EVENT = 'sds.input.select.cleared';
    _classThis.CARET_CHANGED_EVENT = 'sds.input.select.caret.changed';
    _classThis.INPUT_CLICKED_EVENT = 'sds.input.select.input.clicked';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsInputSelect = _classThis;
})();
export { SdsInputSelect };
